// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_ie-0";
export var fulfillmentPanelBody = "_ie-1";